import { Home } from 'src/components/home';

export const HomePage = () => <Home />;
